module.exports = __webpack_public_path__ + "about_04.b34e7d472cee42f1aff1.png";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/img/about_04.png
// module id = ../../../../../src/assets/img/about_04.png
// module chunks = main